(ns guidebook.views.financial-priorities
  (:require
    [cljss.core :as cljss]
    [css.core :refer [defstyled get-theme]]
    [css.icons :refer [feeling-icon]]
    [css.vars :as vars]
    [guidebook.common :refer [format-date]]
    [util.core :refer [long-str valid-date?]]
    [very.re-frame.core :as rf]
    ["moment" :as moment]))

(defstyled financial-priorities-s :div
  {:display "grid"
   :padding "150px 100px"
   :grid-template-columns "66.66fr 33.33fr"
   :grid-gap "0 20rem"
   ::cljss/media {[:print]
                  {:grid-template-columns "min-content"
                   :padding "0 0 8rem"}}})


(defstyled header-s :div
  {:grid-row "1"
   :display "inline-block"
   ::cljss/media {[:print]
                  {:grid-row "1"
                   :background "black"
                   :padding "92px 100px"}}})

(defstyled title-s :h1
  {:font-size "94px"
   :font-weight 300
   :text-transform "uppercase"
   :margin-bottom "2rem"
   :line-height "110px"
   :color "black"
   ::cljss/media {[:print]
                  {:font-size "68px"
                   :line-height "80px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin-bottom "1rem"
                   :color "white"}}})

(defstyled body-s :div
  {:color "black"
   :font-size "25px"
   :font-weight "300"
   :line-height "36px"
   :text-align "right"
   ::cljss/media {[:print]
                  {:text-align "left"
                   :font-size "20px"
                   :color "white"
                   :line-height "32px"
                   :width "680px"}}})

(defstyled box-s :div
  {::cljss/media {[:print]
                  {:width "50%"
                   :margin-left "auto"}}})

(defstyled priorities-s :ol
  {:padding-top "5rem"
   :grid-row "1"
   ::cljss/media {[:print]
                  {:grid-row "2"
                   :padding "2rem 0 2rem 6.25rem"}}})

(defstyled priority-s :li
  {:display "grid"
   :grid-template-columns "min-content 1fr"
   :padding "2rem 1rem"
   :border-top (str "1px solid " vars/border-light)
   :&:last-child {:border-bottom (str "1px solid " vars/border-light)}
   ::cljss/media {[:print]
                  {:max-width "38.75rem"
                   :page-break-inside "avoid"}}})

(defstyled p-number-s :div
  {:font-size "1.625rem"
   :font-weight "400"
   :margin-right "2rem"
   ::cljss/media {[:print]
                  {:font-size "1.125rem"}}})

(defstyled p-title-s :h2
  {:font-size "1.625rem"
   :font-weight "300"
   ::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :font-size "1.125rem"}}})

(defstyled goals-s :ul
  {:padding-top ".5rem"
   ::cljss/media {[:print]
                  {:padding ".5rem 0 0"}}})

(defstyled goal-s :li
  {:display "grid"
   :grid-template-columns "[title-start] 1fr [title-end date-start] max-content [date-end feeling-start] min-content [feeling-end]"
   :align-items "center"
   :grid-gap "0 1.5rem"
   :padding-top ".5rem"})

(defstyled goal-date-s :span
  {:text-align "right"
   :grid-column "date"
   :font-size "1.25rem"
   :font-weight "300"
   ::cljss/media {[:print]
                  {:font-size "1.125rem"}}})

(defstyled goal-date-before-s :span
  {:text-align "right"
   :color "red"})

(defstyled goal-date-after-s :span
  {:text-align "right"})

(defstyled feeling-icon-wrapper-s :div
  {:grid-column "feeling"})

(defstyled date-s :span
  {:color "white"
   :background-color (get-theme :primary)
   :position "absolute"
   :left "0"
   :top "5rem"
   :font-size "25px"
   :font-weight "300"
   :line-height "25px"
   :height "70px"
   :display "flex"
   :align-items "center"
   :justify-content "center"
   :padding "0 3.5rem"
   ::cljss/media {[:print]
                  {:right "0"
                   :left "auto"
                   :font-size "1.25rem"
                   :top "3.125rem"}}})

(defstyled goal-title-s :h4
  {:font-size "1.3rem"
   :grid-column "title"
   ::cljss/media {[:print]
                  {:-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :font-size "1.125rem"}}})

(defn- goal-date [g]
  (when (:target-date g)
    (let [date (moment (:target-date g))]
      [goal-date-s (.fromNow date)])))

(defn goals-view [goals]
  (when (not-empty goals)
    [goals-s
     (for [g goals]
       ^{:key (:id g)}
       [goal-s
        [goal-title-s (:title g)]
        [goal-date g]
        [feeling-icon-wrapper-s
         [feeling-icon (:feeling g)]]])]))

(defn priorities-view [priorities]
  [priorities-s
   (for [p priorities]
     ^{:key (:id p)}
     [priority-s
      [p-number-s (inc (:order p))]
      [:div
       [p-title-s (:title p)]
       [goals-view (:goals p)]]])])

(defn main []
  (let [data (rf/subscribe [:guidebook/priorities])]
    (fn []
      (let [priorities (:priorities @data)
            last-modified (:last-modified @data)]
        [financial-priorities-s
         (when (valid-date? last-modified)
           [date-s (str "Last updated on " (format-date last-modified))])
         [priorities-view priorities]
         [header-s
          [title-s "Financial Priorities"]
          [body-s "Achieving your goals is easier when you have clear priorities. Your priorities should be a balance of concerns across your lifetime and beyond."]]]))))
